import { supabase } from '@/lib/supabase'

/**
 * Restore a soft-deleted record by clearing deleted_at and deleted_by.
 */
export async function restoreRecord(
  tableName: string,
  id: string
): Promise<void> {
  const { error } = await supabase
    .from(tableName)
    .update({ deleted_at: null, deleted_by: null } as Record<string, unknown>)
    .eq('id', id)

  if (error) throw error
}
